import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';
import { comparator } from '@fi-shared/utils/array-sort-comparators';

@Component({
    selector: 'fi-customer-billing-customer-edit-customer-information',
    templateUrl: './customer-billing-customer-edit-customer-information.component.html',
    styleUrls: ['./customer-billing-customer-edit-customer-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-edit-customer-information' },
    standalone: false,
})
export class CustomerBillingCustomerEditCustomerInformationComponent implements OnInit {
    @Input() customer: CustomerBillingCustomerModel;
    contactPerson: BillingContactModel;

    ngOnInit(): void {
        this.contactPerson = this.customer.Contacts.sort(comparator((item) => item.IsDefault, true))[0];
    }
}
